// @flow
import React from 'react';
import cx from 'classnames';
import Postpone from '../Postpone/Postpone';
import './FakePostCard.scss';
import GrayBoxes from '../GrayBoxes';
import GrayBox from '../GrayBox';

type Props = {
  oneColumn?: boolean,
  isTrending?: boolean,
};

const FakePostCard = ({ oneColumn, isTrending }: Props) => (
  <Postpone duration={100}>
    <div className={cx('PostCard FakePostCard', { 'one-column': oneColumn, mobile: isTrending })}>
      <div className="thumbnail-wrapper">
        <img
          src="https://images.cacheby.com/placeholder.png?s=600x316&t=crop&q=82&f=webp"
          alt="thumbnail"
        />
      </div>
      <div className="card-content">
        {!oneColumn && <div className="user-thumbnail-wrapper" />}
        <div className="content-head">
          <div className="username">
            <GrayBox min={6} max={8} />
          </div>
          <h3>
            <GrayBoxes countMin={7} countMax={7} />
          </h3>
          <div className="subinfo">
            <GrayBox min={4} max={4} />
            <GrayBox min={5} max={5} />
            <GrayBox min={5} max={5} />
          </div>
          <div className="price">
            <GrayBox min={4} max={4} />
            <GrayBox min={5} max={5} />
          </div>
        </div>
      </div>
    </div>
  </Postpone>
);

FakePostCard.defaultProps = {
  oneColumn: false,
};

export default FakePostCard;



// WEBPACK FOOTER //
// ./src/components/common/FakePostCard/FakePostCard.js